import InteractiveApi from '../api/InteractiveApi';
import {AsyncResult, fromResult, Loaded, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import {changeInteractiveFormData, getInteractiveFormData, InteractiveFormActionType} from '../ducks/Interactive';
import {InteractiveForm, InteractiveFormStateDto} from '../models/Interactive';
import {createSnackbar} from "Core/ducks/snackbar";
import {
    changeInteractiveFormStates,
    getInteractiveFormStates,
    InteractiveFormStateActionType
} from "../ducks/interactiveFormState";

export function* getInteractiveFromApi(action: ReturnType<typeof getInteractiveFormData>) {
    const {page, filter, sort} = action.payload;
    if (page) {
        yield put(changeInteractiveFormData(new LoadingAdditional(page)));
    } else {
        yield put(changeInteractiveFormData(new Loading(page)));
    }

    const result: AsyncResult<Page<InteractiveForm>> = yield page
        ? call(mergeWithNextPage, {existingPage: page})
        : call(InteractiveApi.getInteractiveForms, action.payload.claims, page, action.payload.isNewYork, filter, sort);

    yield pipe(
        result,
        E.map(fromResult),
        E.fold(
            value => put(changeInteractiveFormData(value)),
            value => put(changeInteractiveFormData(value))
        )
    );
}

export function* getInteractiveFormStatesApi(action: ReturnType<typeof getInteractiveFormStates>) {
    const request = action.payload;
    const result: AsyncResult<InteractiveFormStateDto[]> = yield call(
        InteractiveApi.getInteractiveFormStates,
        request
    );

    if (E.isRight(result)) {
        yield put(changeInteractiveFormStates(new Loaded(result.right)));
    } else {
        yield put(createSnackbar('An error occurred during the View States process. Please try again.'));
    }
}

export function* fetchInteractiveFormSaga() {
    yield takeLatest(InteractiveFormActionType.GET_DATA, getInteractiveFromApi);
}

export function* fetchInteractiveFormStatesSaga() {
    yield takeLatest(InteractiveFormStateActionType.GET_INTERACTIVE_FORM_STATES, getInteractiveFormStatesApi);
}

export default function* () {
    yield all([fetchInteractiveFormSaga(), fetchInteractiveFormStatesSaga()]);
}
